import React from 'react';
import styles from './styles.module.css';
type Props = {
  children: React.ReactNode;
};

export const InfoDiv = ({ children }: Props) => {
  return <div className={styles.infoDiv}>{children}</div>;
};

export default InfoDiv;
